import { useQuery } from "@tanstack/react-query";
import { useAccountStore, useRevenueOverall } from "../../store";
import { getErrorAndTestTransactionApi } from "../../services/record-transaction/get.error.and.test.transaction.api";
export const useGetTotalErrorAndTestApi = () => {
  const { info } = useAccountStore();
  const { startDate, endDate } = useRevenueOverall();
  const { data, isLoading } = useQuery({
    queryKey: ["all-machine-of-store", info?.id, endDate, startDate],
    queryFn: () =>
      getErrorAndTestTransactionApi(
        info?.role === "ROLE_ADMIN" ? undefined : info?.id,
        startDate,
        endDate
      ),
    enabled: false,
  });
  return {
    totalErrorAndTest: data,
    isLoading,
  };
};
